// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@guestsupply/App/Store/Reducers";
import { rmaReturnInformationModel } from "@guestsupply/App/Widgets/RequestRma/RequestRmaReturnInformation";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { ApiParameter, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { addRma as addRmaApi, AddRmaApiParameter } from "@insite/client-framework/Services/OrderService";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/RequestRma/Handlers/SendRmaRequest";
import { BaseModel, RmaLineDto, RmaModel } from "@insite/client-framework/Types/ApiModels";

type CustomSendRmaRequestParameter = {
    orderNumber: string;
    properties: rmaReturnInformationModel;
    onError?: (errorMessage: string) => void;
} & HasOnSuccess<RmaModel>;

export interface CustomRmaModel extends BaseModel {
    message: string;
    notes: string;
    orderNumber: string;
    rmaProperties: rmaReturnInformationModel;
    rmaLines: RmaLineDto[] | null;
}
export interface CustomeAddRmaApiParameter extends ApiParameter {
    rmaModel: CustomRmaModel;
}

type HandlerType = ApiHandlerDiscreteParameter<
    CustomSendRmaRequestParameter,
    AddRmaApiParameter,
    ServiceResult<RmaModel>
>;

export const XngPopulateApiParameter: HandlerType = props => {
    const state = props.getState();
    const orderLines = state.pages.requestRma.orderLines;
    if (orderLines.length === 0) {
        return false;
    }
    // XNG-CHANGES GSS-508 : Changing the order rmaProperties to properties and customerInformation to string
    const rmaProperties = (state as CustomAppState).xRmaReturnInformation.properties;
    const properties = {
        ...rmaProperties,
        customerInformation: JSON.stringify(rmaProperties.customerInformation),
    };

    props.apiParameter = {
        rmaModel: {
            orderNumber: props.parameter.orderNumber,
            properties,
            notes: state.pages.requestRma.returnNotes || "",
            rmaLines: orderLines
                .map(orderLine => {
                    return {
                        line: orderLine.lineNumber,
                        rmaQtyRequested: orderLine.rmaQtyRequested,
                        rmaReasonCode: orderLine.returnReason,
                    } as RmaLineDto;
                })
                .filter(x => x.rmaQtyRequested > 0),
        } as any,
    };
};

replaceInChain(chain, PopulateApiParameter, XngPopulateApiParameter);
